// extracted by mini-css-extract-plugin
export default {"maxWidth":"Kiosk_maxWidth__Lqn2l","maxHeight":"Kiosk_maxHeight__pNpia"};